import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

// Optum baseline config intentionally relies on the base Optum theme.
// Add only cross-theme defaults here when needed.
export const OPTUM_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {
      "app.color.brand.primary": "$core.color.brand.100",
      "app.color.border.status.error": "$web.semantic.color.border.status.saturated.error",
      "app.color.slot.selected": "#196ECF",
      "app.color.find.member.id.modal.close.button": "#196ECF",
      "app.color.find.member.id.modal.member.id.value": "#201F1F",
      "app.color.find.member.id.modal.divider": "$core.color.pacific.10",
      "app.color.find.member.id.modal.member.id.label": "#233E6F",
      "app.color.find.member.id.modal.annotation.border": "#8061BC",
      "app.color.find.provider.dropdown.border": "$core.color.brand.70",
      "app.color.find.provider.dropdown.text": "$app.color.text.link.rest.primary",
      "app.color.find.provider.dropdown.icon": "$app.color.icon.primary.interactive",
      "app.color.border.muted": "#CCC",
      "app.color.search.banner.error.background": "#FFFBEB",
      "app.color.search.banner.error.border": "#FFC107",
      "app.color.search.banner.error.text": "#856404",
      "app.color.header.text": "#424242",
      "app.color.get.started.header.text": "#3E3C38",
      "app.color.get.started.sub.header.text": "#3E3C38",
      "app.color.get.started.new.patient.text": "#D74120",
      "app.color.get.started.divider": "$web.semantic.color.border.content.secondary",
      "app.color.provider.list.loading.spinner": "$core.color.orange.100",
      "app.color.top.background": "$core.color.aqua.20",
      "app.color.default.background": "$core.color.warm-white.10",
      "app.color.text.primary": "$web.semantic.color.text.content.primary",
      "app.color.text.primary.alt": "$web.semantic.color.text.content.primary-alt",
      "app.color.text.secondary": "$web.semantic.color.text.content.secondary",
      "app.color.toggle.thumb.unchecked": "#929496",
      "app.color.toggle.thumb.checked": "#0C55B8",
      "app.color.text.status.error": "$web.semantic.color.text.status.error",
      "app.color.text.link.rest.primary": "$web.semantic.color.text.interactive.rest.primary",
      "app.color.text.footer.rest": "$web.semantic.color.text.footer.rest",
      "app.color.text.footer.hover": "$web.semantic.color.text.footer.hover",
      "app.color.text.footer.active": "$web.semantic.color.text.footer.active",
      "app.color.surface.container.primary": "$web.semantic.color.surface.container.primary",
      "app.color.surface.container.secondary": "$web.semantic.color.surface.container.secondary",
      "app.color.surface.overlay": "$web.semantic.color.surface.container.overlay",
      "app.color.icon.primary.interactive": "$web.semantic.color.icon.interactive.rest.primary",
      "app.color.header.nav.menu.item": "$core.color.brand.100",
      "app.color.default.border": "$web.semantic.color.border.content.secondary",
      "app.color.active.filter.chip.border":
        "$web.semantic.color.border.interactive.controls.rest.default",
      "app.border.badge.neutral": "$web.semantic.color.border.status.saturated.neutral",
      "app.color.patient.information.footer.link.rest":
        "$web.semantic.color.text.interactive.rest.primary",
      "app.color.patient.information.footer.link.hover":
        "$web.semantic.color.text.interactive.hover.primary",
      "app.color.black": "$core.color.neutral.100",
      "app.color.neutral.dark": "$core.color.neutral.80",
      //disclaimer message color
      "app.color.patient.screener.disclaimer.text": "#0C55B8",
      "app.color.white": "$core.color.neutral.0",
      "app.color.polling.status.icon.inprogress": "$app.color.brand.primary",
      "app.color.polling.status.icon.complete": "$web.semantic.color.icon.status.success",
      "app.color.polling.status.icon.failed": "$web.semantic.color.icon.status.error",
      "app.color.polling.status.icon.neutral": "$core.color.neutral.25",
      "app.color.polling.status.icon.dot.neutral": "$core.color.neutral.60",
      "app.color.polling.status.steprow.border.inprogress": "$badge.color.border.container.info",
      "app.color.polling.status.steprow.background.inprogress":
        "$badge.color.surface.container.info",
      "app.color.location.selection.modal.slot.detail.background":
        "$web.semantic.color.surface.container.status.info.tint",
    },
  },
  assets: {
    icons: {},
  },
  // providerGroupId: #,
};
